import { render, staticRenderFns } from "./materialCategory.vue?vue&type=template&id=363e728f&scoped=true&"
import script from "./materialCategory.vue?vue&type=script&lang=js&"
export * from "./materialCategory.vue?vue&type=script&lang=js&"
import style0 from "./materialCategory.vue?vue&type=style&index=0&id=363e728f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e728f",
  null
  
)

export default component.exports